

































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Form, Message, MessageBox } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import { LoanResponse } from '@/api/model/credit'
import $Api from '@api'
import qs from 'querystring'

@Component({
    components: {
        SearchForm,
        TableForm
    }
})
export default class extends Vue {
    tableData: any = []
    loanCancelData: any = []
    shouldTableLoading: boolean = false
    cancelLoanDialogVisible: boolean = false
    setupDialogVisible: boolean = false
    viewReviewResultDialogVisible: boolean = false

    shouldTimeDateValue = null
    cancelTimeDateValue = null

    searchForm: any = {
        current: 1,
        size: 10,
        cameraId: null,
        state: null,
        cardNo: null,
        appName: null,
        releaseTime: null
    }

    setupFormData = {}
    reviewResultFormData = {}

    setupFormProperty = {
        releaseTime: {
            prop: 'releaseTime',
            label: '放款日期'
        },
        amount2222: {
            prop: 'amount2222',
            label: '放款金额'
        },
        contractAmount: {
            prop: 'contractAmount',
            label: '应放金额'
        },
        haircutAmount: {
            prop: 'haircutAmount',
            label: '砍头息'
        },
        amount: {
            prop: 'amount',
            label: '实放金额'
        }
    }

    reviewResultFormProperty = {
        result: {
            prop: 'result',
            label: '结果'
        },
        remark: {
            prop: 'remark',
            label: '备注'
        }
    }

    multipleSelection: LoanResponse[] = []

    created(): void {
        this.getData()
    }

    getData(): void {
        this.shouldTableLoading = true
        $Api.creditService
            .queryLoanPage(this.searchForm)
            .subscribe(res => {
                this.tableData = res.records
                this.shouldTableLoading = false
            })
    }

    handleCommand(command: string): void {
        const currentRecord = this.multipleSelection[0]

        switch (command) {
            case 'action-cancel':
                this.cancelLoanDialogVisible = true
                break

            case 'action-retry':
                MessageBox
                    .confirm('确定重新发起放款? 操作后不可撤销!', '重试放款', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    })
                    .then(() => {
                        Message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    })
                    .catch(() => {
                        Message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
                break

            case 'action-setup':
                this.setupDialogVisible = true
                break

            case 'action-pay':
                const params = {
                    // indexs: currentRecord.indexs,
                    // lid: currentRecord.lid,
                    // rid: currentRecord.rid
                }
                const queryString = qs.stringify(params)
                this.$router.push({ path: '/credit/result?' + queryString })
                break

            case 'action-review':
                this.viewReviewResultDialogVisible = true
                break
        }
    }

    handleSelectionChange(records: LoanResponse[]): void {
        this.multipleSelection = records
    }

    onSearchSubmit(): void {
        this.getData()
    }

    onCancelLoanSubmit(): void {

    }

    onSetupSubmit(): void {

    }

    reset(formName): void {
        (this.$refs[formName] as Form).resetFields()
    }

    @Watch('shouldTimeDateValue')
    onShouldTimeDateValueChange(date: Array<Date>): void {
        const [ shouldTimeBegin, shouldTimeEnd ] = date
        if (date === null) {
            this.searchForm.shouldTimeBegin = null
            this.searchForm.shouldTimeEnd = null
        } else {
            this.searchForm.shouldTimeBegin = shouldTimeBegin
            this.searchForm.shouldTimeEnd = shouldTimeEnd
        }
    }

    @Watch('cancelTimeDateValue')
    onCancelTimeDateValueChange(date: Array<Date>): void {
        const [ cancelTimeBegin, cancelTimeEnd ] = date
        if (date === null) {
            this.searchForm.cancelTimeBegin = null
            this.searchForm.cancelTimeEnd = null
        } else {
            this.searchForm.cancelTimeBegin = cancelTimeBegin
            this.searchForm.cancelTimeEnd = cancelTimeEnd
        }
    }
}
